import createVanilla, { StoreApi } from "zustand/vanilla";
import create, { UseStore } from "zustand";
import {
	AnalyticsAppEventData,
	AnalyticsEvent,
	AnalyticsEventKind,
	AnalyticsEventModel
} from "client/Api/Analytics/analytics";
import { newGuid } from "client_legacy/ndaw/guid";
import { formatForDto } from "client/DateAndTime/dateTimeUtils";

type AnalyticsStoreModel = {
	events: readonly AnalyticsEventModel[];
	addEvent(event: AnalyticsEvent): void;
	addAppEvent(data: AnalyticsAppEventData): void;
	emptyEvents(): void;
};

export const analyticsStore: StoreApi<AnalyticsStoreModel> = createVanilla(
	(set, get) => ({
		events: [],
		addEvent: (event): void => {
			set(x => {
				const newEvent: AnalyticsEventModel = {
					...event,
					eventId: newGuid(),
					timestamp: formatForDto(new Date()),
				};

				return {
					events: [...x.events, newEvent]
				};
			});
		},
		addAppEvent: (data: AnalyticsAppEventData): void => {
			const newEvent: AnalyticsEvent = {
				...data,
				eventKind: AnalyticsEventKind.App
			};

			get().addEvent(newEvent);
		},
		emptyEvents: () => {
			set({ events: [] });
		}
	})
);

export const useAnalyticsStore: UseStore<AnalyticsStoreModel> = create(analyticsStore);